import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { OktaCallbackComponent } from '@okta/okta-angular';
import { HomeComponent } from './components/home/home.component';
import { RouteId } from './enums/env/routes-id-enum';
import { AdminGuard } from './modules/guards/admin-guard';
import { DeliveriesGuard } from './modules/guards/deliveries-guard';
import { FinanceGuard } from './modules/guards/finance-guard';
import { LogisticGuard } from './modules/guards/logistic-guard';
import { PreInvoicesGuard } from './modules/guards/preinvoices-guard';
import { RoutingService } from './services/Routing.service';

import { ErrorComponent } from './shared/components/error/error.component';
import { AppGuard } from './tinea-components/okta/auth/guards/app-guard';


const sharedRoutes: Routes = [
  { path: 'implicit/callback', component: OktaCallbackComponent },
];

const desktopRoutes: Routes = [
  ...sharedRoutes,
  // default route
  {
    path: '',
    canActivate: [AppGuard],
    component: HomeComponent,
    pathMatch: 'full',
  },
  {
    path: RoutingService.getPathRoute(RouteId.CHARGES_SWAP),
    canActivate: [AppGuard, FinanceGuard],
    loadChildren: () => import('./modules/charges-swap/charges-swap.module').then(m => m.ChargesSwapModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.PREINVOICE_CARRIER),
    canActivate: [AppGuard, PreInvoicesGuard],
    loadChildren: () => import('./modules/preinvoice-carrier/preinvoice-carrier.module').then(m => m.PreinvoiceCarrierModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.INVOICE),
    canActivate: [AppGuard, FinanceGuard],
    loadChildren: () => import('./modules/invoice/invoice.module').then(m => m.InvoiceModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.DELIVERIES),
    canActivate: [AppGuard, DeliveriesGuard],
    loadChildren: () => import('./modules/deliveries/deliveries.module').then(m => m.DeliveriesModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.TANKS),
    canActivate: [AppGuard, LogisticGuard],
    loadChildren: () => import('./modules/tanks/tanks.module').then(m => m.TanksModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.PLANNING),
    canActivate: [AppGuard, LogisticGuard],
    loadChildren: () => import('./modules/planning/planning.module').then(m => m.PlanningModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.USERS),
    canActivate: [AppGuard, AdminGuard],
    loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.SETTINGS),
    canActivate: [AppGuard, AdminGuard],
    loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.CLIENTS),
    canActivate: [AppGuard, AdminGuard],
    loadChildren: () => import('./modules/clients/clients.module').then(m => m.ClientsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.CARRIERS),
    canActivate: [AppGuard, AdminGuard],
    loadChildren: () => import('./modules/carriers/carriers.module').then(m => m.CarriersModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.STATIONS),
    canActivate: [AppGuard, LogisticGuard],
    loadChildren: () => import('./modules/stations/stations.module').then(m => m.StationsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.TERMINALS),
    canActivate: [AppGuard, AdminGuard],
    loadChildren: () => import('./modules/terminals/terminals.module').then(m => m.TerminalsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.MOBILE),
    canActivate: [AppGuard],
    loadChildren: () => import('./modules/mobile/mobile.module').then(m => m.MobileModule)
  },
  {
    path: 'error',
    canActivate: [AppGuard],
    component: ErrorComponent,
    pathMatch: 'full',
  },
  // a wildcard route to intercept invalid URLs
  { path: '**', redirectTo: 'error' }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(
      desktopRoutes, // Desktop by default
      {
    preloadingStrategy: PreloadAllModules,
    enableTracing: true // <-- shows routing events in console, debugging purposes only
}
    ),
  ],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule {}
